import { Box, MenuGroup } from '@chakra-ui/react'
import {
  faFacebook,
  faFacebookMessenger,
  faLinkedin,
  faReddit,
  faTwitter,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons'
import { faCopy } from '@fortawesome/pro-solid-svg-icons'
import { useCallback, useMemo } from 'react'
import { LinkedinShareButton } from 'react-share'

import { SHARE_BUTTON_REF_CODE } from '@/client/services/url/constants'
import { addReferralCodeIfNotPresent } from '@/client/services/url/helpers'

import { useToaster } from '@/components/Toast/useToaster'
import MenuItem from '@/components/UI/MenuItem'

import FacebookMessengerShare from './FacebookMessengerShare'
import FacebookShare from './FacebookShare'
import RedditShare from './RedditShare'
import TwitterShare from './TwitterShare'
import WhatsAppShare from './WhatsAppShare'

export default function ShareMenuGroup({
  url,
  description,
  shortDescription,
}: {
  url: string
  description: string
  shortDescription: string
}): JSX.Element {
  const toast = useToaster()
  const fullUrl = useMemo(() => addReferralCodeIfNotPresent(url, SHARE_BUTTON_REF_CODE), [url])

  const handleCopy = useCallback(async () => {
    await navigator.clipboard.writeText(`${description}\n${fullUrl}`)
    toast({ title: 'Copied to clipboard', status: 'success' })
  }, [description, fullUrl, toast])

  return (
    <MenuGroup
      title="Share to..."
      style={{
        marginTop: '14px',
        // copy-pasta from our Chakra eyebrow text style
        color: 'fg.muted',
        fontSize: '14px',
        lineHeight: '17px',
        textTransform: 'uppercase',
        letterSpacing: 1,
        fontWeight: 600,
      }}
    >
      <MenuItem value="copy" icon={faCopy} label="Copy" onClick={handleCopy} />
      <FacebookShare url={fullUrl}>
        <MenuItem value="fb" icon={faFacebook} label="Facebook" />
      </FacebookShare>
      <Box>
        <FacebookMessengerShare url={fullUrl}>
          <MenuItem value="messenger" icon={faFacebookMessenger} label="Messenger" />
        </FacebookMessengerShare>
      </Box>
      <LinkedinShareButton className="share-icon" url={fullUrl} style={{ width: '100%' }}>
        <MenuItem value="linkedin" icon={faLinkedin} label="LinkedIn" />
      </LinkedinShareButton>
      <Box>
        <RedditShare url={fullUrl} shortDescription={shortDescription}>
          <MenuItem value="reddit" icon={faReddit} label="Reddit" />
        </RedditShare>
      </Box>
      <TwitterShare url={fullUrl} shortDescription={shortDescription}>
        <MenuItem value="twitter" icon={faTwitter} label="Twitter" />
      </TwitterShare>
      <Box>
        <WhatsAppShare url={fullUrl} shortDescription={shortDescription}>
          <MenuItem value="whatsapp" icon={faWhatsapp} label="Whatsapp" />
        </WhatsAppShare>
      </Box>
    </MenuGroup>
  )
}
